import React from 'react';

interface MonthlyDuesModalProps {
  monthlyFee: number;
  onClose: () => void;
}

export default function MonthlyDuesModal({ monthlyFee, onClose }: MonthlyDuesModalProps) {
  const formattedFee = Number.isFinite(monthlyFee)
    ? monthlyFee.toFixed(2)
    : '0.00';

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl max-w-md w-full shadow-xl">
        <div className="p-6">
          <div className="flex justify-between items-start mb-4">
            <h2 className="text-xl font-bold text-gray-900">Monthly Dues</h2>
            <button
              type="button"
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700"
              aria-label="Close"
            >
              ✕
            </button>
          </div>

          <div className="space-y-4 text-gray-700">
            <p className="text-lg">
              Your family&apos;s monthly dues are{' '}
              <span className="font-bold text-ggaa-green">${formattedFee}</span>.
            </p>
            <p>
              Dues are due at the <strong>beginning of each month</strong>.
            </p>
            <p>
              Please place your payment in the <strong>drop box in the shelter</strong>.
            </p>
            <p className="text-sm text-gray-600 border-t border-gray-200 pt-4">
              Online payment is not available through the portal at this time. If you have any
              questions, please contact <strong>Dominic</strong>.
            </p>
          </div>

          <button
            type="button"
            onClick={onClose}
            className="mt-6 w-full py-2.5 bg-ggaa-green text-white rounded-lg font-medium hover:bg-ggaa-dark transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
